export function Loading() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--text-muted)',
      }}
    >
      <div
        className="font-heading"
        style={{ fontSize: 13, letterSpacing: '0.25em', textTransform: 'uppercase' }}
      >
        Loading…
      </div>
    </div>
  );
}
